import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { User } from 'src/app/models';
import { UserInfoResult } from 'src/app/services';
import { environment } from 'src/environments/environment.local';
import { IUserApi } from './interfaces/user-abastract.api';

@Injectable({
  providedIn: 'root'
})
export class ExternalUserApi implements IUserApi {

  constructor(private readonly http: HttpClient) { }

  getUser(userId: number): Observable<User> {
    return this.http.get<UserInfoResult>(environment.api.externalUser.information.replace('{userId}', '' + userId)).pipe(
      map<UserInfoResult, User>(({ data }) => data)
    );
  }

}
